<template>
  <div >
    <div class="box-login">
      <p>
        <small>Utilize o seu CPF para recuperar seu 'acesso'.</small>
      </p>
      <form label-width="120px" @keyup.enter='submit'>
        <el-row class="row-login">
          <el-col :span="24">
           <el-input prefix-icon="fas fa-user" placeholder="CPF" v-model="username"></el-input>
          </el-col>
        </el-row>
        <el-row class="row-login">
          <el-col :span="24">
            <el-button type="success" @click='submit'>Localizar meu cadastro</el-button>
          </el-col>
        </el-row>
      </form>
      <small>
      <p>
        Caso não tenha cadastro, <el-button type="text" size="small" @click='$router.push("/p/cadastro")'>Cadastre-se</el-button>.
      </p>
    </small>

    </div>
  </div>
</template>

<script>
import Store from '@/store'
import axios from 'axios'
export default {
  data() {
      return {
          username: '',
        
      }
  },
  methods:{
    handleClick() {
        console.log('click');
    },
    submit(e){
      e.preventDefault()
      if(this.username.length == 11)
      {
        global.Loading.begin(`Localizando seu cadastro`);
        axios({
          method: 'post',
          url: `${global.base}/api/recuperar-acesso`,
          data: {
            username: this.username
          },
          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
          }).then((r)=>{
            global.Loading.end();
            this.$alert(`Seu cadastro foi localizado. Foi enviado um e-mail para você restaurar seu acesso. Em instantes verifique a caixa de entrada do e-mail: ${r.data}`, 'Cadastro Localizado!', {
              confirmButtonText: 'OK',
              callback: action => {
              }  
            });
          }).catch(()=>{
            global.Loading.end();
              this.$alert(`Não encontramos seu cadastro. O CPF está correto?`, 'Não Localizado!', {
              confirmButtonText: 'OK',
              callback: action => {
                
              }
            })
          })
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .box-login{
  padding:25px;
  background: #FFF;
  width: 400px;
  margin:auto;
  min-height:100px;

 }
 .row-login{
  margin:20px;
 }
</style>
